import { Capacitor } from '@capacitor/core';

/**
 * Проверяет, запущено ли приложение в Capacitor (мобильное приложение)
 */
export const isCapacitor = (): boolean => {
  return Capacitor.isNativePlatform();
};

/**
 * Проверяет, запущено ли приложение в браузере
 */
export const isWeb = (): boolean => {
  return !isCapacitor();
};

/**
 * Получает текущую платформу
 */
export const getPlatform = (): 'ios' | 'android' | 'web' => {
  if (isCapacitor()) {
    return Capacitor.getPlatform() as 'ios' | 'android';
  }
  return 'web';
};

/**
 * Проверяет, является ли платформа iOS
 */
export const isIOS = (): boolean => {
  return getPlatform() === 'ios';
};

/**
 * Проверяет, является ли платформа Android
 */
export const isAndroid = (): boolean => {
  return getPlatform() === 'android';
};

/**
 * Проверяет, является ли платформа мобильной (iOS или Android)
 */
export const isMobile = (): boolean => {
  return isCapacitor();
};



